import { render, staticRenderFns } from "./ModalAddSportStandings.vue?vue&type=template&id=aa419326&"
import script from "./ModalAddSportStandings.vue?vue&type=script&lang=js&"
export * from "./ModalAddSportStandings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports